import React from "react";
import QuickItem from "./QuickItem";

const QuickLink = ({ items = [] }) => {
  return (
    <div className="flex-block">
      {items.map((item, index) => (
        <div key={item.key || item.title || index}>
          <QuickItem {...item} />
        </div>
      ))}
    </div>
  );
};

export default QuickLink;
